import axiosClient from "../../../api/apiClient";

export const APIGetProfiles = () => {
    return axiosClient.get(`/profiles`);
};

export const APIPostProfileLogin = (data: object) => {
    return axiosClient.post(`/profile/swap`, data);
};